export class PatientData {
  id: string; 
  photoUrl: string;
  patientid: string;
  dob: string;
  fullName: string;
  gender: string;
  mobileNo: string;
  emailId: string;
  address: string;
  ssn: string;
  doctorName: string;
  Dob: Date;
  DobDate;
  dobDate;
  zipCode: string;
  firstName: string;
  middleName: string;
  lastName: string;
  eaCountryId: string;
  eaState: string;
  country:string;
  username: string;
  city:string;

}
